const request = require('request');
const config = require('./config');

var getDevolucoes = (token,filters) => {
    return new Promise((resolve,reject) => {
        request({
            headers: {
              'Content-Type': 'application/json',
              'User-Token': token
            },
            uri: config.URL_BACKEND+'/devolucoes',
            method: 'GET',
            qs: filters
          }, (err, res, body) => {
            if (err) return reject(err);
            resolve(body)
          })
    })
}

module.exports = {
  getDevolucoes:getDevolucoes
}